/**
 * KAN-718: журнал писем организации.
 *
 *   GET /api/v1/emails/?search=&client_id=&direction=out|in&page=&page_size=
 *   GET /api/v1/emails/{id}/  - письмо с телом
 */
import apiClient from './client';
import type { EmailDetail, EmailListParams, EmailListResponse } from '@/types/emailMailbox';

const BASE = '/api/v1/emails/';

/** Пустые фильтры в запрос не уходят. */
function cleanParams(params: EmailListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') out[key] = value;
  });
  return out;
}

export const emailsApi = {
  list: async (params: EmailListParams): Promise<EmailListResponse> =>
    (await apiClient.get(BASE, { params: cleanParams(params) })).data,
  get: async (id: string): Promise<EmailDetail> => (await apiClient.get(`${BASE}${id}/`)).data,
};
